import type {CheckoutStore, CheckoutStoreResponse} from "~/types/ticket";
import type {MyCheckoutsOutput} from "~/types/checkout";
import type {EventCheckout} from "~/types/event";

export const useCheckout = () => {
  const eventCheckout = useCookie<EventCheckout>('event-checkout')

  const baseUrl = '/checkouts'
  const {fetch} = useAjax()

  const checkout = async (params: CheckoutStore): Promise<CheckoutStoreResponse | undefined> =>{
    return await fetch<any>(baseUrl + '/store', {
      method: "POST",
      body: params,
    })
  }

  const getAllCheckoutBySessionUser = async (): Promise<MyCheckoutsOutput[]> =>{
    try {
      return await fetch<MyCheckoutsOutput[]>(baseUrl)
    } catch (e: any) {
      return []
    }
  }

  return {checkout, getAllCheckoutBySessionUser, eventCheckout}

}
